import React from 'react';
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore';
import Semaphore from './semaphore';
import { Tooltip } from 'reactstrap';
import UnderlinedTitle from "../../common/underlinedTitle";
import BbPopover from "../../common/popover";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class AmlGlobalEval extends React.Component {
    state = { expanded: this.props.expanded || false };

    toggleContent = () => {
        this.setState(state => ({ expanded: !state.expanded }));
    }

    render() {
        return (
            <React.Fragment>
                <div className="columns is-centered">
                    <div className="column is-narrow">
                        <div className="card aml-global-eval">
                            <div className="card-body">
                                <div className="card-title aml-semaphore">
                                    <span>
                                        <BbPopover amlData={this.props.data} title={this.props.translate("Report.Aml.OverallDecision")} content={this.props.translate("Report.Explanatory.Tooltip")} addInfo={"AmlGlobalEval"} placement="left" targetId={"AmlGlobalEval"}>
                                            <span href="#" className="icon-gray print-hidden" id={"AmlGlobalEval"} style={{ cursor: "pointer" }}><FontAwesomeIcon icon="question-circle" /></span>
                                        </BbPopover>
                                    </span>
                                    <div className="d-inline-block" id='aml-info-overall-decision'>
                                        <UnderlinedTitle header={this.props.translate("Report.Aml.OverallDecision")} />
                                        <Tooltip
                                            placement="top" target={`aml-info-overall-decision`} isOpen={this.state.tooltipOpen}
                                            toggle={() => this.setState({ tooltipOpen: !this.state.tooltipOpen })}
                                            innerClassName='bb-tooltip-inner'
                                        >
                                            {this.props.translate('Report.Aml.DecisionDescription')}
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className="card-text">
                                    <div>
                                        <Semaphore color={this.props.decision} width={43} height={43} className='aml-semaphore-centered' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(AmlGlobalEval));